<template>
    <div class="linepay_success">
        <section class="chapternav-top">
            <div class="container">
                <div class="row">
                  <div class="linepay-success-box">
                    <i class="far fa-7x fa-check-circle"></i><br>
                    <img v-if="!discount && type == 'line'" src="img/parkit/line/linepay_logo.png" alt="" /><br>
                    <img v-if="!discount && type == 'apple'" src="img/parkit/ApplePay-Button_2x.png" alt="" /><br>
                    <h3 v-if="!discount">付款成功</h3>
                    <h3 v-if="discount">過卡成功</h3>
                    <p class="text-muted">
                      {{ returnMessage }}
                    </p>
                  </div>

                </div>
                

            </div>
        </section>
    </div>
</template>

<script>
export default {
  name: 'LinePayFail',
  components: {
  },
  props: {
  },
  data() {
    return {
        returnMessage: "",
        discount: false,
        type: "line"
    }
  },
  mounted() {
      var self = this
      if (self.$route.query.errorCode) {
          self.error = self.errorCodeCollection[self.$route.query.errorCode]
      }

      if (self.$route.query.returnMessage) {
          self.returnMessage = self.$route.query.returnMessage
      }

      if (self.$route.query.discount) {
        self.discount = true
      } else {
        self.discount = false
      }

      if (self.$route.query.type) {
        self.type = self.$route.query.type
      }
  },
  destroyed() {
   
  },
  methods: {
  }
}
</script>
